export default {"src":"/_next/static/media/salasar_logo.f31aafc3.svg","height":133,"width":264,"blurWidth":0,"blurHeight":0};